export default "__VITE_ASSET__CfxQM8vG__"